{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://raw.githubusercontent.com/jwildfire/safety.viz/main/src/data/schema/results-over-time.json",
  "title": "safety.viz results-over-time data contract",
  "description": "Long-format results data with a visit dimension: one record per participant per visit per measure (SROT-DATA-001/002). Column names are supplied by the settings mapping; the renderer removes missing/non-numeric results with a reported count and degrades gracefully when optional columns are absent.",
  "type": "object",
  "required": ["data", "settings"],
  "properties": {
    "data": {
      "type": "array",
      "minItems": 1,
      "items": { "type": "object" },
      "description": "d3.csv()-style records; every row carries the measure, result, and visit columns named in settings."
    },
    "settings": {
      "type": "object",
      "description": "Column mappings and rendering options; merged onto the module's DEFAULT_SETTINGS, so only overrides need to be supplied.",
      "required": ["measure_col", "value_col", "time_col"],
      "properties": {
        "measure_col": {
          "type": "string",
          "default": "TEST",
          "description": "Column holding the measure name; required in data."
        },
        "value_col": {
          "type": "string",
          "default": "STRESN",
          "description": "Column holding the numeric result; required in data."
        },
        "time_col": {
          "type": "string",
          "default": "VISIT",
          "description": "Column holding the visit name; required in data. Distinct visits become the x-axis categories."
        },
        "time_order_col": {
          "type": "string",
          "default": "VISITNUM",
          "description": "Optional numeric column ordering the visits; falls back to alphanumeric order when absent."
        },
        "id_col": {
          "type": "string",
          "default": "USUBJID",
          "description": "Optional participant identifier column driving the participant counts."
        },
        "unit_col": {
          "type": "string",
          "default": "STRESU",
          "description": "Optional unit column, appended to measure labels and the y-axis title."
        },
        "measures": {
          "type": ["array", "null"],
          "items": { "type": "string" },
          "default": null,
          "description": "Ordered whitelist of measures the Measure control offers: only these appear, and in this order. null or [] offers every measure in the data, alphabetically. Configured measures absent from the data are dropped with a console warning (SROT-MEAS-001)."
        },
        "unscheduled_visits": {
          "type": "boolean",
          "default": false,
          "description": "Show unscheduled visits on the x-axis (matched by unscheduled_visit_values, else by unscheduled_visit_pattern). A display toggle: no statistic is re-derived."
        },
        "unscheduled_visit_pattern": {
          "type": "string",
          "default": "/unscheduled|early termination/i",
          "description": "Regular expression, in /source/flags string form, identifying an unscheduled visit (SROT-CFG-017)."
        },
        "unscheduled_visit_values": {
          "type": ["array", "null"],
          "items": { "type": "string" },
          "default": null,
          "description": "Explicit list of unscheduled visit names; takes precedence over unscheduled_visit_pattern when set (SROT-CFG-019)."
        },
        "filters": {
          "$ref": "#/$defs/filterList",
          "description": "Optional filter columns rendered as controls. Each entry is a column name or a { value_col, label, start, all, multiple } spec: `start` is the value the filter opens on, `all` (default true) is whether an \"All\" option is offered, and `multiple` (default false) makes it a checkbox multiselect."
        },
        "groups": {
          "$ref": "#/$defs/fieldList",
          "description": "Optional group-by columns that split each visit into side-by-side box plots."
        }
      }
    }
  },
  "$defs": {
    "fieldList": {
      "type": "array",
      "items": {
        "anyOf": [
          { "type": "string" },
          {
            "type": "object",
            "required": ["value_col"],
            "properties": {
              "value_col": { "type": "string" },
              "label": { "type": "string" }
            }
          }
        ]
      }
    },
    "filterList": {
      "type": "array",
      "items": {
        "anyOf": [
          { "type": "string" },
          {
            "type": "object",
            "required": ["value_col"],
            "properties": {
              "value_col": { "type": "string" },
              "label": { "type": "string" },
              "start": {
                "type": ["string", "number", "boolean", "array", "null"],
                "default": null,
                "description": "The value the filter opens on; an array of values for a `multiple` filter. 0 and false are real values, not an absent start. A value the data lacks is dropped with a console warning."
              },
              "all": {
                "type": "boolean",
                "default": true,
                "description": "Whether the filter offers an \"All\" option. false removes it, and the filter then always holds one value: the first, unless `start` names another."
              },
              "multiple": {
                "type": "boolean",
                "default": false,
                "description": "Render a checkbox multiselect instead of a dropdown; the rows shown are those matching any selected value."
              }
            }
          }
        ]
      }
    }
  }
}
